import { HoursByDay, HoursOfOperation } from "@myphx-engineering/phx-design-system";
import { jsx } from "react/jsx-runtime";

//#region src/components/pharmacy-info/PharmacyHours.tsx
const PharmacyHours = ({ day, hours, showIcon, weeklyHours }) => {
	if (Array.isArray(hours)) return /* @__PURE__ */ jsx(HoursOfOperation, {
		day: !!hours[0] && !!hours[1] ? day : void 0,
		weeklyHours,
		times: hours,
		showIcon,
		inline: true
	});
	return /* @__PURE__ */ jsx(HoursByDay, {
		hours,
		showIcon
	});
};

//#endregion
export { PharmacyHours };